import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
